<template>
    <div v-if="project" class="project__item-container">
        <div class="project__item-outer">
            <div class="project__item">
                <div class="project__item-inner">
                    <div class="item-inner__top"
                         :style='`background-color: ${project.color || "#112060"};`'>
                        <div class="favorite">
                            <v-btn v-ripple
                                   small
                                   absolute
                                   dark
                                   fab
                                   top
                                   left
                                   @click="toggleStar"
                                   color="transparent">
                                <v-icon v-if="is_starred">mdi-star</v-icon>
                                <v-icon v-if="!is_starred">mdi-star-outline</v-icon>
                            </v-btn>
                        </div>
                        <v-menu transition="slide-y-transition"
                                left
                                bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn v-ripple
                                       small
                                       absolute
                                       dark
                                       fab
                                       top
                                       right
                                       v-on:click="openMenu(on, $event)"
                                       transition="scroll-y-transition"
                                       color="transparent">
                                    <v-icon>mdi-dots-horizontal</v-icon>
                                </v-btn>
                            </template>
                            <v-list class="list__menu list__menu--lefty">
                                <v-list-item class="list__menu-item">
                                    <v-list-item-title class="list__menu-text">
                                        <v-icon>mdi-dots-horizontal</v-icon>
                                    </v-list-item-title>
                                </v-list-item>
                                <!-- <v-list-item @click="editProject()" v-ripple class="list__menu-item">
                                    <v-list-item-title class="list__menu-text">
                                        <v-img :src="require('@/assets/img/icons/pen.svg')"></v-img>
                                        <span>Edit</span>
                                    </v-list-item-title>
                                </v-list-item> -->
                                <!-- <v-list-item @click="copyProject()" v-ripple class="list__menu-item">
                                    <v-list-item-title class="list__menu-text">
                                        <v-img :src="require('@/assets/img/icons/duplicate.svg')"></v-img>
                                        <span>Duplicate</span>
                                    </v-list-item-title>
                                </v-list-item> -->
                                <v-list-item v-if="can_delete" v-ripple @click="openDeleteConfirmation()" class="list__menu-item">
                                    <v-list-item-title class="list__menu-text">
                                        <v-img :src="require('@/assets/img/icons/trash.svg')"></v-img>
                                        <span>Delete</span>
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item v-else v-ripple="{ class: 'error--text' }" class="list__menu-item">
                                    <v-list-item-title class="list__menu-text">
                                        <v-img :src="require('@/assets/img/icons/trash.svg')"></v-img>
                                        <span>Delete</span>
                                    </v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </div>

                    <router-link :to="`/projects/project/${project.id}`"
                                 v-ripple
                                 class="item-inner__bottom">
                        <v-avatar :max-height="40"
                                  :max-width="40"
                                  :min-width="40"
                                  color="white"
                                  class="avatar">
                            <!--                            <v-img :src=""></v-img>-->
                        </v-avatar>
                        <h2 class="item__caption">{{project.name}}</h2>
                        <v-chip v-if="false" class="item__chip">lorem ipsum</v-chip>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from "axios";
    import {store} from "../../store/store";
    import {projectCan} from '../../services/project.service';

    export default {
        name: "ProjectsItem",
        props: ['project', 'value'],
        data: () => ({
            is_starred: false,
            can_delete: false,
        }),
        methods: {
            openMenu(on, e) {
              this.can_delete = false;
              if (projectCan('delete_project', this.project.domain_id, this.project.id)){
                this.can_delete = true;
              }
              on.click(e);
            },
            openDeleteConfirmation() {
                this.$router.push({
                    name: 'DeleteProjectConfirmation',
                    params: {
                        id: this.project.id,
                        type: 'project',
                        name: this.project.name,
                        returnToCompName: 'Projects',
                        dialog: true
                    }
                });
                this.$emit('dialogOpened')
            },
            copyProject: function () {
                this.$emit('projectCopied', this.name)
            },
            toggleStar: function () {
                store.dispatch('getAccessToken').then(resp => {
                        const token = resp;
                        axios.patch(`/projects/${this.project.id}`, {
                                is_starred: !this.is_starred
                            },
                            {
                                headers: {Authorization: "Bearer " + token}
                            }).then(resp => {
                            this.is_starred = resp.data.project.is_starred
                        })
                    }
                )

            },
        },
        mounted() {
            this.is_starred = this.project.is_starred;
        },
        watch: {
            is_starred: {
                handler: function (val) {
                    this.$emit('projectUpdated', {
                        id: this.project.id,
                        is_starred: val
                    })
                },
                deep: true
            }
        }
    }
</script>

<style scoped>

</style>
